import React from 'react';  
  
const InfoTable = ({ query }) => {  
  const extractFields = (query) => {  
    const fields = {  
      directoryNetworkScheduleId: '',  
      coverageType: '',  
      memberEffectiveDate: '',  
      preEffectiveDataCheck: '', 
    };  
  
    const regex = {  
      directoryNetworkScheduleId: /directoryNetworkScheduleId,\s*codeSetValue:\s*"([^"]*)"/,  
      coverageType: /coverageType,\s*codeSetValue:\s*"([^"]*)"/,  
      memberEffectiveDate: /memberEffectiveDate,\s*codeSetValue:\s*"([^"]*)"/,  
      preEffectiveDataCheck: /preEffectiveDataCheck,\s*codeSetValue:\s*"([^"]*)"/,  
    };  
  
    for (const key in fields) {  
      const match = regex[key].exec(query);  
      if (match) {  
        fields[key] = match[1];  
      }
    }  
    return fields;  
  };  
  
  const fields = extractFields(query);  
  
  return (  
    <table className="info-table">  
      <tbody>  
        <tr>  
          <td>Directory Network Schedule ID</td>  
          <td>{fields.directoryNetworkScheduleId}</td>  
        </tr>  
        <tr>  
          <td>Coverage Type</td>  
          <td>{fields.coverageType}</td>  
        </tr>  
        <tr>  
          <td>Member Effective Date</td>  
          <td>{fields.memberEffectiveDate}</td>  
        </tr>  
        <tr>  
          <td>Pre-Effective Data Check</td>  
          <td>{fields.preEffectiveDataCheck}</td>  
        </tr>  
      </tbody>  
    </table>  
  );  
};  
  
export default InfoTable;  
